import { render, staticRenderFns } from "./CardHolders.vue?vue&type=template&id=276412bb&scoped=true"
import script from "./CardHolders.vue?vue&type=script&lang=js"
export * from "./CardHolders.vue?vue&type=script&lang=js"
import style0 from "./CardHolders.vue?vue&type=style&index=0&id=276412bb&prod&lang=scss&scoped=true"
import style1 from "./CardHolders.vue?vue&type=style&index=1&id=276412bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276412bb",
  null
  
)

export default component.exports